import { ref } from 'vue';

export interface Toast {
  id: number;
  message: string;
  type: 'success' | 'error' | 'info';
}

export const toasts = ref<Toast[]>([]);

let nextId = 0;

export function showToast(message: string, type: Toast['type'] = 'info') {
  const id = ++nextId;
  toasts.value.push({ id, message, type });
  setTimeout(() => dismissToast(id), 4000);
}

export function dismissToast(id: number) {
  toasts.value = toasts.value.filter((toast) => toast.id !== id);
}